import Modal from "../modal/Modal";
import { Button } from "../buttons";
import React from "react";

function ConfirmDeletePositionModal({
  openModal,
  setOpenModal,
  submitHandler,
  content,
  title,
  buttonId,
}) {
  return (
    <Modal
      size="2xl"
      dismissible
      show={openModal}
      onClose={() => setOpenModal(false)}
    >
      <Modal.Header className="bg-[#FFE7E7]">{title}</Modal.Header>
      <Modal.Body>
        {content.map((line, index) =>
          line.trim() !== "" ? (
            <p key={index} className="">
              {line}
            </p>
          ) : (
            <br key={index} />
          )
        )}
      </Modal.Body>
      <Modal.Footer className="justify-center space-x-[16px] w-full">
        <div className="w-1/2">
          <Button
            color="light"
            className="w-full"
            onClick={() => setOpenModal(false)}
          >
            閉じる
          </Button>
        </div>
        <div className="w-1/2">
          <Button
            color="red"
            className="w-full"
            onClick={submitHandler}
            id={buttonId}
          >
            削除
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmDeletePositionModal;
